import MergeHeader from './view'

export default MergeHeader
